<form [formGroup]="edit.form" (ngSubmit)="onEditProjectClick()">
    <app-input imusRequired [label]="'Имя'" formControlName="name" [outline]="true" [required]="true"></app-input>
    <field-errors formFieldName="name">
        <field-error-label rule="required"  message="Поле обязательно для заполнения"></field-error-label>
    </field-errors>
    <div class="separator"></div>
    <h3>Исполнитель</h3>
    <app-input imusRequired [label]="'Компания'" formControlName="contractorCompany" [required]="true"></app-input>
    <field-errors formFieldName="contractorCompany">
        <field-error-label rule="required" message="Заполните название компании"></field-error-label>
    </field-errors>
    <div class="separator"></div>
    <app-input [label]="'Контактное лицо'" formControlName="contractorRepresentative"></app-input>
    <field-errors formFieldName="contractorRepresentative"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'E-mail'" [type]="inputType.email" formControlName="contractorEmail"></app-input>
    <field-errors formFieldName="contractorEmail"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Телефон'" [type]="inputType.tel" formControlName="contractorPhone"></app-input>
    <field-errors formFieldName="contractorPhone"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Город'" formControlName="contractorCity"></app-input>
    <field-errors formFieldName="contractorCity"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Индекс'" [type]="inputType.number" formControlName="contractorZip"></app-input>
    <field-errors formFieldName="contractorZip"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Улица'" formControlName="contractorStreet"></app-input>
    <field-errors formFieldName="contractorStreet"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Web'" formControlName="contractorWeb"></app-input>
    <field-errors formFieldName="contractorWeb"></field-errors>
    <div class="separator"></div>
    <app-text-area [label]="'Описание'" formControlName="contractorNotes"></app-text-area>

    <div class="separator"></div>
    <h3>Заказчик</h3>
    <app-input imusRequired [label]="'Компания'" formControlName="clientCompany" [required]="true"></app-input>
    <field-errors formFieldName="clientCompany">
        <field-error-label rule="required" message="Заполните название компании">
        </field-error-label>
    </field-errors>
    <div class="separator"></div>
    <app-input [label]="'Контактное лицо'" formControlName="clientRepresentative"></app-input>
    <field-errors formFieldName="clientRepresentative"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'E-mail'" [type]="inputType.email" formControlName="clientEmail"></app-input>
    <field-errors formFieldName="clientEmail"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Телефон'" [type]="inputType.tel" formControlName="clientPhone"></app-input>
    <field-errors formFieldName="clientPhone"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Город'" formControlName="clientCity"></app-input>
    <field-errors formFieldName="clientCity"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Индекс'" [type]="inputType.number" formControlName="clientZip"></app-input>
    <field-errors formFieldName="clientZip"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Улица'" formControlName="clientStreet"></app-input>
    <field-errors formFieldName="clientStreet"></field-errors>
    <div class="separator"></div>
    <app-input [label]="'Web'" formControlName="clientWeb"></app-input>
    <field-errors formFieldName="clientWeb"></field-errors>
    <div class="separator"></div>
    <app-text-area [label]="'Описание'" formControlName="clientNotes"></app-text-area>
    <field-errors formFieldName="clientNotes"></field-errors>
    <div class="separator"></div>
</form>


<section class="panel-action">
    <!-- mat-dialog-close -->
    <button mat-raised-button color="primary" [disabled]="!isValid" (click)="onEditProjectClick()">Изменить</button>
    <button mat-raised-button color="danger" (click)="onCancelClick()">Отменить</button>
</section>